import moment from 'moment'

const mixin = {
  data () {
    return {
      rules: {},
      validated: false,

      rule: {
        required: message => {
          return value => {
            message = message || this.$t('validation.required')
            if (Array.isArray(value)) {
              return value.length > 0 || message
            }
            return (!this.isFalseOrWhitespace(value)) || message
          }
        },
        email: message => {
          return value => {
            message = message || this.$t('validation.invalidEmail')
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return !value || pattern.test(value) || message
          }
        },
        url: message => {
          return value => {
            message = message || this.$t('validation.invalidUrl')
            const pattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi
            return !value || typeof (value) !== 'string' || pattern.test(value) || message
          }
        },
        maxLength: (max, message) => {
          return value => {
            if (!message && value) {
              message = Array.isArray(value) ? this.$t('validation.maxLengthArray', { max }) : this.$t('validation.maxLengthString', { max })
            }
            return !value || value.length <= max || message
          }
        },
        unique: (array, message) => {
          return value => {
            message = message || this.$t('validation.unique')
            return !value || !array.includes(value) || message
          }
        },
        dateLaterThen: (comparedDate, message) => {
          return value => {
            const comparedDateObj = new Date(comparedDate)
            const dateObj = new Date(value)
            const dateLaterThenComparedDate = comparedDateObj.getTime() < dateObj.getTime()
            const dateLocal = moment.utc(comparedDate).local()
            const date = `${dateLocal.format('YYYY-MM-DD')} ${dateLocal.format('HH:mm')}`
            message = message || this.$t('validation.dateLaterThen', { date })
            return !value || dateLaterThenComparedDate || message
          }
        },
        imageNotLargerThenMb: (megabites, message) => {
          return file => {
            const isImage = file?.type?.startsWith('image')
            const isLargerThenMb = file?.size > megabites * 1024 * 1024
            const imageLargerThenMb = isImage && isLargerThenMb
            message = message || this.$t('validation.imageNotLargerThenMb', { megabites })
            return !file || !imageLargerThenMb || message
          }
        }
      }
    }
  },


  methods: {
    validateEmail (email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },

    isFalseOrWhitespace (value) {
      if (typeof value === 'string') {
        return !value.trim()
      }
      if (value === 0) {
        return false
      }
      return !value
    },

    async validate (rules, formRef = 'form') {
      this.rules = rules

      await this.$nextTick()

      if (this.$refs[formRef]) {
        this.validated = true
        return this.$refs[formRef].validate()
      }

      return true
    },

    resetValidation (formRef = 'form') {
      this.rules = {}

      if (this.$refs[formRef]) {
        this.validated = false
        this.$refs[formRef].resetValidation()
      }
    },

    async scrollToFirstError () {
      await this.$nextTick(() => {
        document.getElementsByClassName('error--text')[0].scrollIntoView({ behavior: 'smooth' })
      })
    }
  }
}

export default mixin
